import { writable } from 'svelte/store';

import FingerprintJS from '@fingerprintjs/fingerprintjs'

export const fp = writable(false);

;(async () => {
  // Get the visitor identifier when you need it.
  const res = await FingerprintJS.load();
  const visitorId = await (await res.get()).visitorId;
  fp.set(visitorId);
})()

